/* Pretty in Pink: header in de opbouw van Loavies (fase 2, groep 19, 30-09-2026). Hoort bij sections/pip-header-lv.liquid.
   - de balk blijft staan met position: sticky (groep 21; eerder fixed met een top per scroll-event, dat haperde)
   - --header-height krijgt de hoogte van de balk (de collectiepagina en de productpagina rekenen daarmee)
   - menu bij hover op desktop (met een kleine vertraging), ook met toetsenbord en met een eerste tik op een touchscherm
   - menu en zoeken schuiven van links in; Escape, het kruisje en de donkere achtergrond sluiten ze
   - werkt ook na het opnieuw laden van de sectie in de thema-editor */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pipHdrReady) return;
    root.dataset.pipHdrReady = '1';
    /* de sectie zelf krijgt de stapelvolgorde (zie css), ook in browsers zonder :has() */
    if (root.parentElement && root.parentElement.classList.contains('shopify-section')) root.parentElement.classList.add('pip-hdr-section');

    var bar = root.querySelector('[data-pip-hdr-bar]');
    var overlay = root.querySelector('[data-pip-hdr-overlay]');
    var mqDesk = window.matchMedia('(min-width: 990px)');
    var mqTouch = window.matchMedia('(hover: none)');

    /* ---------- de balk ---------- */
    /* groep 21 (30-09-2026): de balk plakt met position: sticky (zie css); javascript zet alleen nog de hoogte in
       --header-height. De top werd eerder per scroll-event bijgesteld en dat hapert op een telefoon. */
    function place() {
      if (!bar) return;
      bar.style.top = '';
      var h = bar.offsetHeight || 60;
      root.style.setProperty('--pip-hdr-bar', h + 'px');
      document.documentElement.style.setProperty('--header-height', h + 'px');
      document.documentElement.style.setProperty('--pip-hdr-bottom', h + 'px');
    }
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    place();
    window.setTimeout(place, 250);
    if ('ResizeObserver' in window && bar) {
      new ResizeObserver(place).observe(bar);
    }

    /* ---------- menu bij hover (desktop) ---------- */
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pip-hdr-item]'));
    var openItem = null;
    var hoverTimer = null;
    function panelLink(li) { return li.querySelector(':scope > .pip-hdr__link'); }
    function closePanel() {
      if (!openItem) return;
      openItem.classList.remove('is-open');
      var a = panelLink(openItem);
      if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
      openItem = null;
    }
    function openPanel(li) {
      if (!li.classList.contains('has-sub')) { closePanel(); return; }
      if (openItem === li) return;
      closePanel();
      li.classList.add('is-open');
      var a = panelLink(li);
      if (a) a.setAttribute('aria-expanded', 'true');
      openItem = li;
    }
    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!mqDesk.matches) return;
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () { openPanel(li); }, 80);
      });
      li.addEventListener('mouseleave', function () {
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () { if (openItem === li) closePanel(); }, 150);
      });
      li.addEventListener('focusin', function () { if (mqDesk.matches) openPanel(li); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) closePanel();
      });
      var a = panelLink(li);
      if (a && li.classList.contains('has-sub')) {
        /* touchscherm op desktopbreedte (tablet): eerste tik opent het menu, tweede tik volgt de link */
        a.addEventListener('click', function (e) {
          if (!mqDesk.matches || !mqTouch.matches) return;
          if (openItem !== li) { e.preventDefault(); openPanel(li); }
        });
      }
    });
    var nav = root.querySelector('[data-pip-hdr-nav]');
    if (nav) {
      nav.addEventListener('mouseleave', function () {
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(closePanel, 150);
      });
    }
    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) closePanel();
    });

    /* ---------- panelen van links: menu en zoeken ---------- */
    var flys = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-pip-hdr-fly]'), function (f) {
      flys[f.getAttribute('data-pip-hdr-fly')] = f;
    });
    var current = null;
    var closeTimer = null;

    function setExpanded(name, on) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pip-hdr-open="' + name + '"]'), function (b) {
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    function openFly(name, trigger) {
      var f = flys[name];
      if (!f) return;
      if (current && current !== f) closeFly(true);
      window.clearTimeout(closeTimer);
      closePanel();
      current = f;
      f.hidden = false;
      if (overlay) overlay.hidden = false;
      void f.offsetWidth;
      f.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.documentElement.classList.add('pip-hdr-lock');
      setExpanded(name, true);
      var first = name === 'search' ? f.querySelector('input[type="search"]') : f.querySelector('[data-pip-hdr-close]');
      if (window.pipFocus) {
        window.pipFocus.on(f, first, trigger || null);
      } else if (first) {
        window.setTimeout(function () { first.focus(); }, 320);
      }
    }
    function closeFly(silent) {
      if (!current) return;
      var f = current;
      current = null;
      f.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.documentElement.classList.remove('pip-hdr-lock');
      setExpanded('menu', false);
      setExpanded('search', false);
      var ps = f.querySelector('predictive-search');
      if (ps && typeof ps.close === 'function') { try { ps.close(false); } catch (e) {} }
      closeTimer = window.setTimeout(function () {
        if (!f.classList.contains('is-open')) f.hidden = true;
        if (overlay && !overlay.classList.contains('is-open')) overlay.hidden = true;
      }, 320);
      if (window.pipFocus) {
        if (silent) { try { window.pipFocus.off(f); } catch (e) {} } else { window.pipFocus.off(f); }
      }
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pip-hdr-open]');
      if (t) { e.preventDefault(); openFly(t.getAttribute('data-pip-hdr-open'), t); return; }
      if (e.target.closest('[data-pip-hdr-close]')) { closeFly(false); return; }
      var acc = e.target.closest('[data-pip-hdr-acc]');
      if (acc) {
        var sub = document.getElementById(acc.getAttribute('aria-controls'));
        var isOpen = acc.getAttribute('aria-expanded') === 'true';
        acc.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (sub) sub.hidden = isOpen;
        var li = acc.closest('li');
        if (li) li.classList.toggle('is-open', !isOpen);
      }
    });
    if (overlay) overlay.addEventListener('click', function () { closeFly(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePanel(); if (current) closeFly(false); }
    });
    /* naar desktopbreedte: het mobiele menu dicht */
    var onMq = function () { if (mqDesk.matches && current && current.getAttribute('data-pip-hdr-fly') === 'menu') closeFly(true); };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onMq); else if (mqDesk.addListener) mqDesk.addListener(onMq);
    /* accountpaneel geopend vanuit het menu: het menu dicht (het accountpaneel regelt zijn eigen scrollen) */
    var acct = document.getElementById('account-drawer');
    if (acct && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (acct.classList.contains('is-open') && current) closeFly(true);
      }).observe(acct, { attributes: true, attributeFilter: ['class'] });
    }
    /* link in het menu aangeklikt (zelfde pagina met #): menu dicht */
    Array.prototype.forEach.call(root.querySelectorAll('.pip-hdr__fly a[href^="#"]'), function (a) {
      a.addEventListener('click', function () { closeFly(true); });
    });

    /* ---------- thema-editor: blok (uitgelichte foto) geselecteerd, dan dat menu open ---------- */
    root.pipHdrOpenPanelFor = function (el) {
      var li = el && el.closest ? el.closest('[data-pip-hdr-item]') : null;
      if (li) openPanel(li);
    };
    root.pipHdrClose = function () { closePanel(); closeFly(true); };
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pip-hdr]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-pip-hdr]') : null;
    if (r) init(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-pip-hdr]')) {
      document.documentElement.classList.remove('pip-hdr-lock');
    }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var r = document.querySelector('[data-pip-hdr]');
    if (r && r.pipHdrOpenPanelFor && r.contains(e.target)) r.pipHdrOpenPanelFor(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var r = document.querySelector('[data-pip-hdr]');
    if (r && r.pipHdrClose && r.contains(e.target)) r.pipHdrClose();
  });
})();
